export default __webpack_public_path__ + "static/media/bikeInsurance.878028cc.svg";